var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgAssignmentInd = function SvgAssignmentInd(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    d: "M12 8c1.383 0 2.5 1.117 2.5 2.5S13.383 13 12 13a2.497 2.497 0 0 1-2.5-2.5C9.5 9.117 10.617 8 12 8ZM17 16.833V18H7v-1.167c0-1.666 3.333-2.583 5-2.583 1.667 0 5 .917 5 2.583Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    fillRule: "evenodd",
    d: "M8.714 1.906 7.64 3.25H6A2.75 2.75 0 0 0 3.25 6v13A2.75 2.75 0 0 0 6 21.75h12A2.75 2.75 0 0 0 20.75 19V6A2.75 2.75 0 0 0 18 3.25h-1.64l-1.073-1.343v-.001a1.75 1.75 0 0 0-1.367-.656h-3.839c-.532 0-1.034.242-1.367.656Zm1.171.938a.25.25 0 0 1 .196-.094h3.839a.25.25 0 0 1 .196.094l1.134 1.419V5a.25.25 0 0 1-.25.25H9A.25.25 0 0 1 8.75 5v-.737l1.135-1.42ZM16.75 5v-.25H18c.69 0 1.25.56 1.25 1.25v13c0 .69-.56 1.25-1.25 1.25H6c-.69 0-1.25-.56-1.25-1.25V6c0-.69.56-1.25 1.25-1.25h1.25V5c0 .966.784 1.75 1.75 1.75h6A1.75 1.75 0 0 0 16.75 5Z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAssignmentInd);
export default ForwardRef;